export default __webpack_public_path__ + "static/Footprint-mobile-3782dcb38355eb37ba6c14fe9f0a0af4.png";